import AgTechGrid from '@agtech/web/components/Grids/AgTechGrid';
import AgTechGridLink from '@agtech/web/components/Grids/Controls/AgTechGridLink';
import { ContactCredit } from '@sales/data/operation/contacts/credits/ContactCreditData';
import React from 'react'
import ContactCreditDialog from '../../dialogs/credits/SaleContactCreditDialog';
import { SaleContactCreditsActionButton } from '../buttons/SaleContactButtons';
import { useAgTechOptionalQuery } from '@agtech/core/data/queries/AgTechDataQueries';
import { ContactCreditsGetContactCreditsQuery } from '@sales/data/operation/contacts/credits/ContactCreditDataQueries';
import { AgTechGridPropsModifier } from '@agtech/web/components/Grids/Data/AgTechGridProps';
import { AgTechContact } from '@agtech/data/contacts/ContactData';

export type ContactCreditsGridProps = {
    contact: AgTechContact,
    credits?: ContactCredit[],
    modifyGridProps?: AgTechGridPropsModifier<ContactCredit>
}

const ContactCreditsGrid = (props: ContactCreditsGridProps) => {
    const gridQuery = useAgTechOptionalQuery({
        query: ContactCreditsGetContactCreditsQuery,
        queryContext: props.contact.id,
        data: props.credits,
        projection: data => ({
            items: data
        })
    });

    return (
        <AgTechGrid
            data={{
                itemQuery: gridQuery
            }}
            header={{
                title: 'Credits',
            }}
            columns={[
                {
                    header: "Amount",
                    value: credit => credit.creditAmount.toLocaleString('en-US', {
                        style: 'currency',
                        currency: 'USD',
                    }),
                    classes: 'bg-slate-100 emphasized centered',
                    width: '100px'
                },
                {
                    header: 'Description',
                    value: credit => 
                        <AgTechGridLink
                            content={credit.description}
                            onClick={(e => e.dialogs.openDialog({
                                dialog: () => (
                                    <ContactCreditDialog
                                        contactId={props.contact.id}
                                        creditId={credit.id}
                                    />
                                )
                            }))}
                        />,
                    size: 2
                }
            ]}
            isRowEntityTheSame={(prev, curr) => {
                return prev.creditAmount === curr.creditAmount &&
                    prev.description === curr.description;
            }}
            noRecordsConfig={{
                message: 'No credits were found for this contact',
                action: {
                    prompt: 'To create one, click the button below',
                    button: () => (
                        <ContactCreditDialog.Button
                            contactId={props.contact.id}
                            classes='button-highlight'
                        />
                    )
                }
            }}
            actions={{
                rendering: credit => {
                    return (
                        <SaleContactCreditsActionButton
                            contact={props.contact}
                            credit={credit}
                        />
                    )
                }
            }}
            propModifier={props.modifyGridProps}
        />
    )
}

export default ContactCreditsGrid;